import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { MessageDialogService } from './services/message-dialog.service';

export const apiErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const messageDialogService = inject(MessageDialogService);

  return next(request).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        switch (err.status) {
          case 400: {
            if (err.error.code === 50008) {
              messageDialogService.showMessage({
                text: err.error.message,
                type: 'error',
              });
            } else {
              messageDialogService.showMessage({ type: 'error' });
            }
            break;
          }
          case 403:
          case 404: {
            messageDialogService.showMessage({
              text: err.error.message,
              type: 'error',
            });
            break;
          }
          case 302: {
            if (err.error.code === 3064 || err.error.code === 3048) {
              messageDialogService.showMessage({ type: 'error' });
            } else {
              messageDialogService.showMessage({
                text: err.error.message,
                type: 'error',
              });
            }
            break;
          }
          default: {
            messageDialogService.showMessage({ type: 'error' });
            break;
          }
        }
      }
      return throwError(() => err);
    }),
  );
};
